"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";

const ZaynScorecardSection = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const stats = t("zaynScorecard.items", { returnObjects: true }) || [];

  // "47 → 7 days" ya "47 ← 7 أيام" ko arrow par split karke icon lagata hai
  const renderValue = (value) => {
    const parts = String(value).split(/\s*[→←]\s*/);
    if (parts.length !== 2) return value;

    return (
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: { xs: 0.8, sm: 1 },
        }}
      >
        <span>{parts[0]}</span>
        <ArrowForwardIcon
          sx={{
            fontSize: { xs: 18, sm: 20, md: 22 },
            color: "#FFFFFF",
            // bold look dene ke liye stroke
            stroke: "#FFFFFF",
            strokeWidth: 1.5,
            transform: isArabic ? "rotate(180deg)" : "none",
          }}
        />
        <span>{parts[1]}</span>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        py: { xs: 5, sm: 6, md: 8 },
        bgcolor: "#14132B",
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          sx={{
            fontSize: { xs: "11px", sm: "12px" },
            fontWeight: 600,
            color: "#B58BFF",
            textTransform: "uppercase",
            letterSpacing: "1px",
            fontFamily: "var(--font-outfit)",
            textAlign: "center",
            mb: { xs: 1, sm: 1.5 },
          }}
        >
          {t("zaynScorecard.label")}
        </Typography>

        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "24px", sm: "28px", md: "32px" },
            fontWeight: 700,
            lineHeight: 1.3,
            color: "#FFFFFF",
            fontFamily: "var(--font-plusjakarta)",
            textAlign: "center",
            mb: { xs: 3, sm: 4, md: 5 },
          }}
        >
          {t("zaynScorecard.title")}
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
            gap: { xs: 2, sm: 2.5, md: 3 },
          }}
        >
          {stats.map((item, index) => (
            <Box
              key={index}
              sx={{
                bgcolor: item.highlight ? "#7A2BF5" : "#222038",
                borderRadius: "16px",
                p: { xs: 2.5, sm: 4 },
                textAlign: isArabic ? "right" : "left",
              }}
            >
              <Typography
                component="div"
                sx={{
                  fontSize: { xs: "20px", sm: "22px", md: "24px" },
                  fontWeight: 700,
                  color: "#FFFFFF",
                  fontFamily: "var(--font-plusjakarta)",
                  mb: { xs: 0.5, sm: 0.4 },
                }}
              >
                {renderValue(item.value)}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "13px" },
                  color: item.highlight ? "#F0E6FF" : "#DED9F0",
                  lineHeight: 1.6,
                  fontWeight: 400,
                  fontFamily: "var(--font-outfit)",
                }}
              >
                {item.caption}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ZaynScorecardSection;